<template>
	<div v-if="show" class="container" :class="{'is-mobile':mobileFlag}">
		<div class="content">
			<div class="content-item content-item-left" :style="{backgroundImage:'url(' + envLogo + ')'}">
				<span class="content-version">Version1.0</span>
			</div>
			<div class="content-item content-item-right">
				<!-- <span class="close">
				 <a-icon type="close" />
				</span>-->
				<div class="right-header">
					<img :src="envTextLogo" alt/>
					<span class="login-title">登录账户</span>
				</div>
				<div class="right-content right-content-tabs">
					<div class="right-content-tab" v-show="isPassword==0">
						<div class="right-phone">
							<input
									type="text"
									@keydown="enterLogin($event)"
									@focus="focus('phoneName')"
									v-model="phoneName"
									placeholder="请输入手机号"
									@blur="test()"
							/>
						</div>
						<div class="right-line"></div>
						<div class="help-line help-phone" v-show="isphonecode">
							<span>{{phoneErrMsg}}</span>
						</div>
						<div class="right-password">
							<input
									class="input-tick"
									@keydown="enterLogin($event)"
									@focus="focus('codeWord')"
									v-model="codeWord"
									type="text"
									placeholder="请输入验证码"
							/>
							<span class="login-tick">
                <span
		                v-show="sendAuthCode"
		                class="auth_text auth_text_blue"
		                @click="getAuthCode"
                >获取验证码</span>
                <span v-show="!sendAuthCode" class="auth_text">
                  <span class="auth_text_blue">{{auth_time}}</span> s后重新发送
                </span>
								<!-- <span><a-icon type="eye-invisible" /></span>
								<span><a-icon type="eye" /></span>-->
              </span>
						</div>
						<div class="right-line"></div>
						<div class="help-line help-password" v-show="iscodeErr">
							<span>{{codeErrMsg}}</span>
						</div>
						<div style="height:30px;"></div>
					</div>
					<div class="right-content-tab" v-show="isPassword==1">
						<div class="right-phone">
							<input
									type="text"
									@keydown="enterLogin($event)"
									@focus="focus('userName')"
									v-model="userName"
									placeholder="请输入用户名"
							/>
						</div>
						<div class="right-line"></div>
						<div class="help-line help-phone" v-show="isUserNameErr">
							<span>{{message}}</span>
						</div>
						<div class="right-password">
							<input
									:type="tType"
									@keydown="enterLogin($event)"
									@focus="focus('passWord')"
									v-model="passWord"
									placeholder="请输入密码"
							/>
							<!-- <input :type="tType" v-model="passWord" placeholder="请输入密码" @blur="testWord()"> -->
							<span class="login-eye">
                <span v-show="isEye" @click="getEye()">
                  <a-icon type="eye-invisible"/>
                </span>
                <span v-show="!isEye" @click="getEye()">
                  <a-icon type="eye"/>
                </span>
              </span>
						</div>
						<div class="right-line"></div>
						<div class="help-line help-password">
							<span v-show="ispassErr">密码格式错误</span>
						</div>
						<div class="auto-login">
              <span class="auto-span">
                <!-- <input type="checkbox">
                自动登录-->
              </span>
							<span class="forget-password">
                <span @click="toPassword()" style="cursor: pointer;">忘记密码？</span>
              </span>
						</div>
					</div>
				</div>
				<div class="right-footer">
					<input type="text" @keydown="enterLogin($event)" style="display:none"/>
					<a-button class="login-btn login-in" :loading="isHttpSubmit" @click="doLogin()">登录</a-button>
					<div class="login-linelist">
						<img src="@/assets/image/homeImg/or.png" alt/>
					</div>
					<div class="login-tab">
						<a-button class="pass-login login-btn" v-show="isPassword==1" @click="changeTab()">验证码登录
						</a-button>
						<a-button class="code-login login-btn" v-show="isPassword==0" @click="changePass()">密码登录
						</a-button>
					</div>
				</div>
			</div>
			<div class="content-uec-login" @click="blankUec()"></div>
			<!-- <component :is="componentName" @regist="handleRegist" class="main-content"></component> -->
		</div>
		<!-- <global-footer :copyright="copyright" /> -->
	</div>
</template>

<script>
  import {mapMutations} from "vuex";
  import db from '../../common/localstorage'
  import NProgress from 'nprogress'
  import 'nprogress/nprogress.css'

  const logoUrl = require("" + process.env.VUE_APP_LOGIN_LOGO + "")
  const logoTextUrl = require("" + process.env.VUE_APP_LOGIN_TEXT_LOGO + "")
  // import Cookies from 'js-cookie'
  // import GlobalFooter from '../common/GlobalFooter'
  // import Login from './Login'
  // import Regist from './Regist'
  // import { environment } from '@/environments/environment'
  export default {
    name: "Common",
    // components: {GlobalFooter},
    data() {
      return {
        envLogo: logoUrl,
        envTextLogo: logoTextUrl,
        isHttpSubmit: false,
        phoneErrMsg: '',
        codeErrMsg: '',
        componentName: "Login",
        show: false,
        isPassword: 1,
        userName: "", //用户名
        passWord: "", // 密码
        phoneName: "", //用户名
        codeWord: "", //验证码
        activeKey: "1",
        tType: "password",
        isEye: true,
        isUserNameErr: false,
        isphoneErr: false, //手机红色
        ispassErr: false,
        isphonecode: false,
        iscodeErr: false,
        sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
        auth_time: 0 /*倒计时 计数器*/,
        message: "用户名信息不对",
        mobileFlag: false
      };
    },
    computed: {
      systemName() {
        return this.$store.state.setting.systemName;
      },
      copyright() {
        return this.$store.state.setting.copyright;
      }
    },
    created() {
      // 方便开发测试
      // if (window.location.href.indexOf('http://localhost')==-1){
      //   window.location.href = process.env.VUE_APP_LOGIN_URL;
      // }else{
      //   this.show = true
      // }
      this.show = true;
      // this.enterLogin();
      this.clear();
      this.mobileFlag = this.isMobile();
    },
    methods: {
      isMobile() {
        const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag?true:false;
      },
      clear() {
        this.userName = ""; //用户名
        this.passWord = ""; // 密码
        this.phoneName = ""; //用户名
        this.codeWord = "";
        this.isphoneErr = false;
        this.ispassErr = false;
        this.isphonecode = false;
        this.iscodeErr = false;
      },
      blankUec() {
        const openUrl = process.env.VUE_APP_BLANK_UEC_URL;
        window.open(openUrl);
      },
      createAllMenus(result, menu) {
        result.push({
          id: menu.id,
          name: menu.title || menu.name,
          path: menu.path,
          component: menu.component,
          children: menu.children
        });
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach(element => {
            this.createAllMenus(result, element);
          });
        }
      },
      setUserMenus(username, callback) {
        this.$get("menu/" + username).then(res => {
          db.saveLoaclStorage("userMenus", res.data);
          const userMenus = res.data;
          const allMenus = [];
          userMenus[0].children.forEach(item => {
            this.createAllMenus(allMenus, item);
          });
          db.saveLoaclStorage("userMenusAllMenus", allMenus);
          if (callback) callback();
        });
      },
      handleRegist(val) {
        this.componentName = val;
      },
      changeTab() {
        this.clear();
        this.isPassword = 0;
      },
      changePass() {
        this.clear();
        this.isPassword = 1;
      },
      getEye() {
        this.isEye = !this.isEye;
        if (this.isEye == true) {
          this.tType = "password";
        } else {
          this.tType = "input";
        }
      },
      test() {
        let reg = /^1[0-9]{10}$/;
        if (this.isPassword == 1) {
          if (
            this.phoneName == "" ||
            this.phoneName.length <= 10 ||
            !reg.test(this.phoneName)
          ) {
            this.isphoneErr = true;
            return false;
          } else {
            this.isphoneErr = false;
          }
        } else {
          if (this.phoneName == "") {
            this.phoneErrMsg = '请输入手机号';
            this.isphonecode = true;
            return false;
          } else if (this.phoneName.length <= 10 ||
            !reg.test(this.phoneName)) {
            this.phoneErrMsg = '手机格式错误';
            this.isphonecode = true;
            return false;
          } else {
            this.isphonecode = false;
            return true
          }
        }
      },
      testword() {
        var patrn = /^[0-9A-Za-z]{8,18}$/;
        if (!patrn.test(this.passWord)) {
          this.ispassErr = true;
          return false;
        } else {
          this.ispassErr = false;
          return true;
        }
      },
      testCode() {
        var patrn = /^[0-9]{6}$/;
        if (!patrn.test(this.codeWord)) {
          this.iscodeErr = true;
          return false;
        } else {
          this.iscodeErr = false;
          return true;
        }
      },
      getAuthCode: function () {
        if (!this.test(this.phoneName)) {
          return;
        }
        this.codeWord = '';
        let _this = this;
        this.sendAuthCode = false;
        let phoneName = this.phoneName;
        this.auth_time = 60;
        let data = {
          type: "login",
          mobile: phoneName
        };

        this.$post("/info/smsMsg/open/send", {
          type: "login",
          mobile: phoneName
        })
          .then(r => {
          })
          .catch(e => {
          });
        var auth_timetimer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);
      },
      focus(n) {
        if (n === 'userName') {
          this.isUserNameErr = false;
        } else if (n === 'passWord') {
          this.ispassErr = false;
        } else if (n === 'codeWord') {
          this.iscodeErr = false;
        } else if (n === 'phoneName') {
          this.isphonecode = false;
        } else if (n === 'codeWord') {
          this.iscodeErr = false;
        }

      },
      doLogin() {
        // userName
        let loginTye = "";
        if (this.isPassword === 1) {
          if (this.regx.testUser.test(this.userName)) {
            loginTye = "account";
          } else {
            this.message = "用户名不正确";
            this.isUserNameErr = true;
            return;
          }
          if (!this.testword()) {
            return;
          }
          // 用户名密码登录
          // this.form.validateFields(['name', 'password'], (errors, values) => {
          //   if (!errors) {
          // this.loading = true
          let name = this.userName;
          let password = this.passWord;
          // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
          this.isHttpSubmit = true;
          NProgress.start();
          this.$post("login", {
            loginType: loginTye,
            username: name,
            password: password
          })
            .then(r => {
              let data = r.data.data;
              this.isHttpSubmit = false;
              NProgress.done();
              this.saveLoginData(data);
              this.setUserMenus(data.user.username, () => {
                this.$router.push("/workbench");
              });
            })
            .catch(e => {
              this.isHttpSubmit = false;
              NProgress.done();
            });
        }
        //  验证码登录
        if (this.isPassword === 0) {
          if (this.test(this.phoneName)) {
            loginTye = "mobile";
          } else {
            this.message = "手机格式不正确";
            return;
          }
          if (this.codeWord === '') {
            this.iscodeErr = true;
            this.codeErrMsg = '请获取验证码';
            return;
          } else if (this.codeWord === '') {
            this.iscodeErr = true;
            this.codeErrMsg = '验证码不能为空'
            return;
          } else if (!this.testCode(this.codeWord)) {
            this.codeErrMsg = '验证码为6位数字'
            return;
          }
          let phoneName = this.phoneName;
          let code = this.codeWord;
          this.isHttpSubmit = true;
          NProgress.start();
          this.$post("/login", {
            mobile: phoneName,
            phoneVerificationCode: code,
            loginType: "mobile"
          })
            .then(r => {
              let data = r.data.data;
              this.saveLoginData(data);
              this.isHttpSubmit = false;
              NProgress.done();
              this.setUserMenus(data.user.username, () => {
                this.$router.push("/workbench");
              });
            })
            .catch(e => {
              this.isHttpSubmit = false;
              NProgress.done();
            });
        }
      },
      enterLogin(e) {
        var _self = this;

        if (e.keyCode === 13) {
          _self.doLogin();
        }
      },
      ...mapMutations({
        setToken: "account/setToken",
        setExpireTime: "account/setExpireTime",
        setUploadFile: "account/setUploadFile",
        setPermissions: "account/setPermissions",
        setRoles: "account/setRoles",
        setUser: "account/setUser",
        setTheme: "setting/setTheme",
        setLayout: "setting/setLayout",
        setMultipage: "setting/setMultipage",
        fixSiderbar: "setting/fixSiderbar",
        fixHeader: "setting/fixHeader",
        setColor: "setting/setColor"
      }),
      saveLoginData(data) {
        data.user.mainBusiness = "";
        this.setUploadFile({
          fileHost: data.fileHost,
          userImportExcelTemplate: data.userImportExcelTemplate
        });
        this.setToken(data.token);
        this.setExpireTime(data.exipreTime);
        this.setUser(data.user);
        this.setPermissions(data.permissions);
        this.setRoles(data.roles);
        if (data.config) {
          this.setTheme(data.config.theme);
          this.setLayout(data.config.layout);
          this.setMultipage(data.config.multiPage === "1");
          this.fixSiderbar(data.config.fixSiderbar === "1");
          this.fixHeader(data.config.fixHeader === "1");
          this.setColor(data.config.color);
        }
      },
      toPassword() {
        this.$router.push("/loginpass");
      }
    }
  };
</script>

<style lang="scss" scoped>
	.container {
		display: flex;
		flex-direction: column;
		height: 100vh;
		overflow-y: hidden;
		background: #fff url("../../assets/image/homeImg/bj.jpg") no-repeat center;
		background-size: cover;
		padding: 110px 133px 133px 133px;
		.content {
			display: block;
			font-size: 0;
			width: 900px;
			margin: 0 auto 192px;
			justify-content: center;
			align-items: center;
			.content-uec-login {
				cursor: pointer;
				width: 98px;
				height: 32px;
				margin: 0 auto;
				margin-top: 10px;
				background: url("../../assets/image/imgHome/uec_login_logo_normal.png") no-repeat center;
			}
			.content-uec-login:hover {
				background: url("../../assets/image/imgHome/uec_login_logo_hover.png") no-repeat center;
			}
			.content-item {
				width: 450px;
				height: 450px;
				position: relative;
			}
			.content-item-left {
				background: url("../../assets/image/homeImg/logo.jpg") no-repeat center;
				background-size: cover;
				display: inline-block;
			}
			.content-version {
				position: absolute;
				bottom: 9px;
				right: 15px;
			}
			.content-item-right {
				width: 450px;
				height: 450px;
				position: relative;
				background: linear-gradient(
								0deg,
								rgba(245, 252, 255, 1) 0%,
								rgba(255, 255, 255, 1) 100%
				);
				box-shadow: 0px 44px 88px 48px rgba(0, 0, 0, 0.6);
				display: inline-block;
				vertical-align: top;
				.close {
					position: absolute;
					right: 20px;
					top: 20px;
				}
				.right-header {
					width: 200px;
					height: auto;
					text-align: center;
					display: flex;
					flex-direction: column;
					margin: 45px auto 45px;
					span {
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 36px;
						letter-spacing: 3px;
						color: #050505;
					}
				}
				.right-content,
				.right-footer {
					width: 300px;
					margin: 0 auto;
				}
				.login-tick {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 300;
					color: rgba(62, 127, 255, 1);
					cursor: pointer;
				}
				.right-content {
					.right-phone {
						padding: 0 0 2px 0;
						input {
							width: 240px;
							border: 0 none;
							outline: 0 none;
							background: none;
							font-size: 12px;
							height: 36px;
						}
						input::placeholder {
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(195, 195, 195, 1);
							line-height: 36px;
						}
						//  border-bottom: 1px solid
					}
					.right-line {
						width: 300px;
						height: 1px;
						background: rgba(0, 0, 0, 1);
						opacity: 0.08;
					}
					.help-line {
						height: 20px;
						font-size: 12px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(229, 19, 19, 1);
						line-height: 20px;
					}
					.right-password {
						padding: 20px 0 2px 0;
						display: flex;
						justify-content: space-between;
						align-content: center;

						input:-webkit-autofill,
						select:-webkit-autofill {
							// -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
						}
						input:-internal-autofill-selected {
							background-color: transparent !important;
						}
						input {
							width: 250px;
							border: 0 none;
							outline: 0 none;
							background: none;
							-webkit-appearance: none;
							-webkit-user-select: text;
							outline-color: transparent;
							box-shadow: none;
							font-size: 12px;
							height: 36px;
							-webkit-tap-highlight-color: rgba(255, 0, 0, 0);
							// -webkit-tap-highlight-color:rgba(0,0,0,0);
						}
						input::placeholder {
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(195, 195, 195, 1);
							line-height: 36px;
						}
						input.input-tick {
							width: 200px;
						}
					}
					.auto-login {
						display: flex;
						justify-content: space-between;
						align-content: center;
						span {
							height: 12px;
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(22, 34, 50, 1);
							line-height: 20px;
						}
					}
				}
				.right-footer {
					margin-top: 20px;
					.login-btn {
						width: 300px;
						height: 42px;
						border-radius: 4px;
						text-align: center;
						line-height: 42px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(255, 255, 255, 1);
						cursor: pointer;
					}
					.login-in {
						background: rgba(62, 127, 255, 1);
					}
					.pass-login,
					.code-login {
						border: 1px solid rgba(195, 195, 195, 1);
						font-size: 12px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(159, 159, 159, 1);
					}
				}
			}
		}

		// .content {
		//   padding: 32px 0;
		//   flex: 1;
		//   @media (min-width: 768px){
		//     padding: 116px 0 10px;
		//   }
		//   .main-content {
		//     width: 368px;
		//     margin: 0 auto;
		//     @media screen and (max-width: 576px) {
		//       width: 95%;
		//     }
		//     @media screen and (max-width: 320px) {
		//       .captcha-button{
		//         font-size: 14px;
		//       }
		//     }
		//   }
		// }
	}
  .is-mobile {
    padding: 110px 0 0 0;
    .content {
      width: 450px;
      .content-item-left {
        display: none;
      }
      .content-item-right {
        width: 450px
      }
    } 
  }
</style>
